var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifangti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.470581 3.29685L7.05882 0.489502L15.5294 2.36107L9.88235 6.10419L0.470581 3.29685Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.470581 11.7188V3.29675L9.88235 6.1041V15.4619L0.470581 11.7188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88232 15.4619V6.10409L15.5294 2.36096V10.783L9.88232 15.4619Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01285 0L16 1.9857V11.0022L9.96808 16L0 12.0356V2.98828L7.01285 0ZM7.10479 0.978923L1.84766 3.21907L9.80552 5.59274L14.3508 2.57992L7.10479 0.978923ZM15.0588 3.23529L10.3529 6.35456V14.463L15.0588 10.5639V3.23529ZM9.41177 14.7709V6.45228L0.941176 3.92567V11.4021L9.41177 14.7709Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifangti);
export default __webpack_public_path__ + "static/media/lifangti.061888824393306ea40e07e04994e600.svg";
export { ForwardRef as ReactComponent };